import {
  DOWNLOAD_PORTABILITY_ERROR,
  DOWNLOAD_PORTABILITY_STORAGE,
  DOWNLOAD_PORTABILITY_SFTP,
} from '_models/redux/types';

const initialState = {
  loading: false,
  error: null,
};

const downloadPortabilityFileReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_PORTABILITY_STORAGE:
    case DOWNLOAD_PORTABILITY_SFTP:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case DOWNLOAD_PORTABILITY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default downloadPortabilityFileReducer;
